<template>
    <div class="window-wrapper window-reg">
        <div class="window-overlay"></div>
        <div class="window">
            <div class="window-inner">
                <div class="window-left">

                </div>
                <div class="window-right">
                    <div class="window-right-inner">
                        <div class="logo">
                            <Logo/>
                        </div>
                        <div class="title">Регистрация</div>
                        <div class="form form-registration">

                            <fieldset class="form-field-input">
                                <label>
                                    <input v-model.trim="user.surname"
                                           name="surname"
                                           ref="surname"
                                           type="text"
                                           v-validate="'required'"
                                           autocomplete="off"
                                    >
                                    <div class="label-text">Фамилия *</div>
                                </label>
                            </fieldset>

                            <fieldset class="form-field-input">
                                <label>
                                    <input v-model.trim="nameAndPatronymic"
                                           name="nameAndPatronymic"
                                           ref="nameAndPatronymic"
                                           type="text"
                                           v-validate="'required'"
                                           autocomplete="off"
                                    >
                                    <div class="label-text">Имя и Отчество *</div>
                                </label>
                            </fieldset>

                            <fieldset class="form-field-input filled"
                                      v-bind:class="{'error-field' : !!errors.firstNot('email', 'required') || registerStatus === registerStatuses.emailTaken}">
                                <label>
                                    <input v-model.trim="user.email"
                                           name="email"
                                           type="text"
                                           autocomplete="off"
                                           ref="email"
                                           @input="registerStatus = registerStatuses.newReg"
                                           v-validate="'required|email'"
                                    >
                                    <div class="label-text">Email *</div>
                                    <div v-show="!!errors.firstNot('email', 'required')" class="msg-form msg-error-field">
                                        {{ errors.firstNot('email', 'required') }}
                                    </div>
                                    <div v-show="registerStatus === registerStatuses.emailTaken"
                                         class="msg-form msg-error-field">
                                        Такой email уже зарегистрирован в системе
                                    </div>
                                </label>
                            </fieldset>

                            <fieldset class="form-field-input filled"
                                      v-bind:class="{'error-field' : !!errors.firstNot('emailRepeat', 'required')}">
                                <label>
                                    <input v-model.trim="emailRepeat"
                                           name="emailRepeat"
                                           type="text"
                                           autocomplete="off"
                                           v-validate="'required|confirmed:email'">
                                    <div class="label-text">Повторите email *</div>
                                    <div v-show="!!errors.firstNot('emailRepeat', 'required')" class="msg-form msg-error-field">{{
                                        errors.firstNot('emailRepeat', 'required') }}
                                    </div>
                                </label>
                            </fieldset>

                            <fieldset class="form-field-input filled"
                                      v-bind:class="{'error-field' : !!errors.firstNot('password', 'required')}">
                                <label>
                                    <input v-model="user.password"
                                           name="password"
                                           type="password"
                                           class="dev-password"
                                           autocomplete="off"
                                           ref="password"
                                           v-validate="{required: true, regex: /^[\dA-Za-z]{4,16}$/}"
                                    >
                                    <div class="label-text">Пароль *</div>
                                    <div  v-show="!!errors.firstNot('password', 'required')" class="msg-form msg-error-field">{{
                                        errors.firstNot('password', 'required') }}
                                    </div>
                                </label>
                            </fieldset>

                            <fieldset class="form-field-input filled"
                                      v-bind:class="{'error-field' : !!errors.firstNot('passwordRepeat', 'required')}">
                                <label>
                                    <input v-model="passwordRepeat"
                                           name="passwordRepeat"
                                           type="password"
                                           class="dev-password"
                                           autocomplete="off"
                                           v-validate="'required|confirmed:password'">
                                    <div class="label-text">Повторите пароль *</div>
                                    <div v-show="!!errors.firstNot('passwordRepeat', 'required')" class="msg-form msg-error-field">{{
                                        errors.firstNot('passwordRepeat', 'required') }}
                                    </div>
                                </label>
                            </fieldset>

                            <div class="window-form-row">
                                <div class="agreement form-field-check">
                                    <label><span class="field-check-wrapper">
                                    <input v-model="checkedAgree"
                                           type="checkbox" name=""><span class="field-check"></span></span> Я согласен с
                                        <router-link :to="{name: 'TermsOfUse'}" target="_blank">пользовательским
                                            соглашением
                                        </router-link>
                                        и
                                        <router-link :to="{name: 'PrivacyPolicy'}" target="_blank">соглашением на
                                            обработку персональных данных
                                        </router-link>
                                    </label>
                                </div>
                            </div>

                            <div class="button-block">
                                <button class="button button-dark"
                                        :disabled="isBlocked || pressed"
                                        type="button"
                                        @click="this.register">Зарегистрироваться
                                </button>
                            </div>

                        </div>

                        <div class="reg-block">
                            <div class="reg-text">
                                Уже есть учетная запись?
                            </div>
                            <button class="button button-border modal-auth">Войти</button>
                        </div>

                    </div>
                </div>
            </div>
            <button class="btn-close">
                <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g>
                        <path d="M1 1L27 27M27 1L1 27" stroke="black"/>
                    </g>
                </svg>
            </button>
        </div>
    </div>

</template>




<script>

    import {Validator} from 'vee-validate';
    import constants from '@/constants';
    import Logo from "../icons/Logo";


    const registerStatusesInternal = Object.freeze({
        newReg: 1,
        success: 2,
        emailTaken: 3
    });

    export default {
        name: 'Registration',
        components: {Logo},
        data() {
            return {
                user: {
                    name: '',
                    surname: '',
                    patronymic: '',
                    email: '',
                    password: ''
                },
                nameAndPatronymic: '',
                emailRepeat: '',
                passwordRepeat: '',
                registerStatuses: registerStatusesInternal,
                checkedAgree: false,
                registerStatus: registerStatusesInternal.newReg,
                pressed: false
            }
        },

        mounted() {
          $('.dev-password').bind('paste', function (e) {
              e.preventDefault();
              return false;
          });
        },

        computed: {
            isBlocked() {
                return !(Object.keys(this.fields).every(key => this.fields[key].valid) && this.checkedAgree)
            }
        },

        methods: {

            async register() {
                this.pressed = true;
                if (!!this.isBlocked) {
                    this.pressed = false;
                    return;
                }
                let names = this.nameAndPatronymic.split(' ');
                let userReg = {
                    surname: this.user.surname,
                    name: names.length > 1 ? names.slice(0, -1).join(' ') : names[0],
                    patronymic: names.length > 1 ? names.slice(-1).join(' ') : '',
                    email: this.user.email,
                    password: this.user.password,
                    language: this.$ml.current
                };
                ym(80365885,'reachGoal','SignUpSubmit');
                let success = await this.$store.dispatch('registration', userReg);
                if (!!success) {
                    this.registerStatus = this.registerStatuses.success;
                    this.$router.push({name: 'RegistrationThanks'})
                    // this.newUser();
                } else {
                    this.registerStatus = this.registerStatuses.emailTaken;
                    this.pressed = false;
                }
            }

        }


    }
</script>